import fetchService from 'common/actions/fetchService';

export const GET_BUS_SEAT_MAP = 'BUS/GET_BUS_SEAT_MAP';

export default function getBusSeatMap(inventoryId) {
  return (dispatch, getState) => {
    const state = getState();
    const busInventory = state.entities.busBookingInventory[inventoryId];
    const { agentId, bookOnBehalf } = state.bus.bookingSearchForm;
    const { userId } = state.bus.userConfig;

    const payload = {
      departureDate: busInventory.departureTime.specificDate,
      skuId: busInventory.skuId,
      providerId: busInventory.providerId,
      routeId: busInventory.routeId,
      agentId: bookOnBehalf && agentId ? agentId : userId,
    };

    return dispatch(
      fetchService(({ pssService }) =>
        pssService.fetch('POST', '/api/v2/busextranetagent/seat/map', payload)
      )
    ).then(({ result }) => {
      dispatch({
        type: GET_BUS_SEAT_MAP,
        payload: {
          ...result.data,
          departureTime: busInventory.departureTime,
        },
      });

      return result.data;
    });
  };
}
